import * as validator from 'validator';
import * as creditcardutils from 'creditcardutils';
import { CountryCode } from '../geo/geo.types';

export const isValidBusinessName = (value: string): boolean => {
  const trimmed = value.trim().replace(/[ ()-/']/g, '');

  if (!trimmed) {
    return true;
  } else {
    return validator.isAlphanumeric(trimmed);
  }
};

export const isValidName = (value: string): boolean => {
  const trimmed = value.trim().replace(/[ ()-/']/g, '');

  if (!trimmed) {
    return true;
  } else {
    return validator.isAlphanumeric(trimmed);
  }
};

export const isValidCalendarEventNote = (value: string): boolean => {
  let trimmed = value.trim();

  while (validator.contains(trimmed, ' ') || validator.contains(trimmed, '-') || validator.contains(trimmed, '\n')) {
    trimmed = trimmed.replace(' ', '');
    trimmed = trimmed.replace('-', '');
    trimmed = trimmed.replace('\n', '');
  }

  if (!trimmed) {
    return true;
  } else {
    return validator.isAlphanumeric(trimmed);
  }
};

// TODO : Bad implementation. Fix this later.
export function isAlphanumeric(value: string): boolean {
  const trimmed = value.trim();

  if (!trimmed) {
    return false;
  } else if (validator.contains(trimmed, ' ')) {
    const splits = trimmed.split(' ');
    return splits.filter((split: string) => !validator.isAlphanumeric(split)).length === 0;
  } else {
    return validator.isAlphanumeric(trimmed);
  }
}

export function isValidEmail(email: string, validErrorMsg: string) {
  if (!email) {
    return '';
  }
  var emails = email.split(';');
  var invalid = false;
  emails.forEach(element => {
    if (!validator.isEmail(element)) {
      invalid = true;
    }
  });
  return invalid ? validErrorMsg : '';
}

export function isValidPhone(phone: string, validErrorMsg: string): string {
  if (!phone) {
    return '';
  }

  // TODO: support different locales
  return (validator.isMobilePhone(phone, 'en-US')) ? '' : validErrorMsg;
}

export function isValidPostalCode(
  postalCode: string, countryCode: CountryCode | string, validErrorMsg: string
) {
  if (!postalCode) {
    return '';
  }

  let postalCodeRegex: RegExp;

  switch (countryCode) {
    case 'US':
      postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
      break;
    case 'CA':
      postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
      break;
    default:
      postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
  }

  return (postalCodeRegex.test(postalCode.toUpperCase())) ? '' : validErrorMsg;
}

export function isValidCreditCard(creditCard: string, validErrorMsg: string) {
  if (!creditCard) {
    return '';
  }

  return (validator.isCreditCard(creditCard)) ? '' : validErrorMsg;
}

export const isValidAmount = (value: string): boolean => {
  const trimmed = value.trim();

  if (!trimmed) {
    return false;
  }

  if (validator.contains(trimmed, '.') && trimmed.split('.').length < 3) {
    const splits = trimmed.split('.');
    if (validator.isNumeric(splits[0]) && validator.isNumeric(splits[1])) {
      return trimmed.split('.')[1].length < 3;
    }
  }

  if (validator.contains(trimmed, '.')) {
    return validator.isNumeric(trimmed.replace('.', ''));
  }

  return validator.isNumeric(trimmed);
};

// options for IsLength
interface IsLengthOptions {
  min?: number;
  max?: number;
}

export function isLength(value: string, options: IsLengthOptions, validErrorMsg: string) {
  if (!value || (!options.min && !options.max)) {
    return '';
  }

  let min = (options.min) ? options.min : 0;
  let max = (options.max) ? options.max : 0;

  let isValidLength = (options.max)
    ? validator.isLength(value, min, max)
    : validator.isLength(value, min);

  return (isValidLength) ? '' : validErrorMsg;
}

export function compareNumber(num1: number, num2: number) {
  if (num1 === num2) {
    return 0;
  } else if (num1 < num2) {
    return -1;
  }
  return 1;
}

export function compareDate(date1: Date, date2: Date) {
  return compareNumber(date1.getTime(), date2.getTime());
}

export const generateEnterValidErrorMessage = (input: string): string => 'Please enter a valid ' + input;

/**
 * New CC validation method. Replace others with this in the future. [Dec 4 2017]
 * @param input CC number in string
 */
export const validateCreditCardNumber = (input: string): boolean =>
  creditcardutils.validateCardNumber(creditcardutils.formatCardNumber(input));



// WEBPACK FOOTER //
// ./src/util/Validation.tsx